import React from 'react';
import _find from 'lodash/find';
import classnames from 'classnames';
import PropTypes from 'prop-types';
// Models
import mCustomer from 'models/cpm/customer';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import { listFeatureSearchFieldShape, listFilterShape } from 'constants/PropTypesShapes';
import { yesNoAsList, toBooleanOrNull, toIntegerOrNull } from 'utils/Tools';
// Components
import FiltersCardTemplate from 'components/templates/FiltersCardTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import TextFieldFilter from 'components/filters/TextFieldFilter';
import ItemsSelectFieldFilter from 'components/filters/ItemsSelectFieldFilter';
import ParkingCategorySelectFieldFilter from 'cpmCarparks/assets/parkingCategories/ParkingCategorySelectFieldFilter';

const CustomerFilters = ({
  fullWidth, withOnDemandCategory, disabled, advanced, nbFiltersApplied, searchFields, field, filters,
  isFieldDisplayable, onFieldChange, onFilterFieldChange, onFilterOperatorChange, onReinit, onSwitch,
}) => {
  const {
    lastname, firstname, parkingCategoryId, email, phone, spaceNumber, withStartedParkings, withStartedBookings,
  } = filters;

  return (
    <div className="px-3 mb-3">
      <FiltersCardTemplate
        disabled={disabled}
        advanced={advanced}
        nbFiltersApplied={nbFiltersApplied}
        onReinit={onReinit}
        onSwitch={onSwitch}
      >
        <React.Fragment>
          {!advanced && (
            <div className={classnames('col-12 col-md-4', { 'col-xl-3': fullWidth })}>
              <BaseListFilter
                field={field}
                searchFields={searchFields}
                onChange={onFieldChange}
              />
            </div>
          )}
          {isFieldDisplayable('lastname') && (
            <div className={classnames('col-12 col-md-4', { 'col-xl-3': fullWidth })}>
              <TextFieldFilter
                label="field.lastname"
                value={lastname.value}
                operator={lastname.operator}
                searchField={_find(searchFields, ['field', 'lastname'])}
                onChange={(value) => onFilterFieldChange('lastname', value)}
                onOperatorChange={(value) => onFilterOperatorChange('lastname', value)}
              />
            </div>
          )}
          {isFieldDisplayable('firstname') && (
            <div className={classnames('col-12 col-md-4', { 'col-xl-3': fullWidth })}>
              <TextFieldFilter
                label="field.firstname"
                value={firstname.value}
                operator={firstname.operator}
                searchField={_find(searchFields, ['field', 'firstname'])}
                onChange={(value) => onFilterFieldChange('firstname', value)}
                onOperatorChange={(value) => onFilterOperatorChange('firstname', value)}
              />
            </div>
          )}
          {isFieldDisplayable('parkingCategoryId') && (
            <div className={classnames('col-12 col-md-4', { 'col-xl-3': fullWidth })}>
              <ParkingCategorySelectFieldFilter
                withOnDemand={withOnDemandCategory}
                parkingCategoryId={toIntegerOrNull(parkingCategoryId.value)}
                onChange={(value) => onFilterFieldChange('parkingCategoryId', value)}
              />
            </div>
          )}
          {isFieldDisplayable('email') && (
            <div className={classnames('col-12 col-md-4', { 'col-xl-3': fullWidth })}>
              <TextFieldFilter
                label="field.email"
                value={email.value}
                operator={email.operator}
                searchField={_find(searchFields, ['field', 'email'])}
                onChange={(value) => onFilterFieldChange('email', value)}
                onOperatorChange={(value) => onFilterOperatorChange('email', value)}
              />
            </div>
          )}
          {isFieldDisplayable('phone') && (
            <div className={classnames('col-12 col-md-4', { 'col-xl-3': fullWidth })}>
              <TextFieldFilter
                label="field.phoneNumber"
                value={phone.value}
                operator={phone.operator}
                searchField={_find(searchFields, ['field', 'phone'])}
                onChange={(value) => onFilterFieldChange('phone', value)}
                onOperatorChange={(value) => onFilterOperatorChange('phone', value)}
              />
            </div>
          )}
          {isFieldDisplayable('spaceNumber') && (
            <div className={classnames('col-12 col-md-4', { 'col-xl-3': fullWidth })}>
              <TextFieldFilter
                label="field.spaceNumber"
                value={spaceNumber.value}
                operator={spaceNumber.operator}
                searchField={_find(searchFields, ['field', 'spaceNumber'])}
                onChange={(value) => onFilterFieldChange('spaceNumber', value)}
                onOperatorChange={(value) => onFilterOperatorChange('spaceNumber', value)}
              />
            </div>
          )}
          {isFieldDisplayable('withStartedParkings') && (
            <div className={classnames('col-12 col-md-4', { 'col-xl-3': fullWidth })}>
              <ItemsSelectFieldFilter
                labelId="field.withStartedParkings"
                value={toBooleanOrNull(withStartedParkings.value)}
                items={yesNoAsList}
                onChange={(value) => onFilterFieldChange('withStartedParkings', value)}
              />
            </div>
          )}
          {isFieldDisplayable('withStartedBookings') && (
            <div className={classnames('col-12 col-md-4', { 'col-xl-3': fullWidth })}>
              <ItemsSelectFieldFilter
                labelId="field.withStartedBookings"
                value={toBooleanOrNull(withStartedBookings.value)}
                items={yesNoAsList}
                onChange={(value) => onFilterFieldChange('withStartedBookings', value)}
              />
            </div>
          )}
        </React.Fragment>
      </FiltersCardTemplate>
    </div>
  );
};

CustomerFilters.propTypes = {
  fullWidth: PropTypes.bool,
  withOnDemandCategory: PropTypes.bool.isRequired,
  // From HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    lastname: listFilterShape,
    firstname: listFilterShape,
    parkingCategoryId: listFilterShape,
    email: listFilterShape,
    phone: listFilterShape,
    spaceNumber: listFilterShape,
    withStartedBookings: listFilterShape,
    withStartedParkings: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onFilterOperatorChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

CustomerFilters.defaultProps = {
  fullWidth: true,
};

module.exports = wrapListFilters(mCustomer.listFeatures.searchFields)(CustomerFilters);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/customers/CustomerFilters.js